<mat-card>
  <mat-card-header>
    <mat-card-title>{{selectedDocInfo.doc_Type_Desc}}</mat-card-title>
  </mat-card-header>
  <mat-card-content fxLayout="column" fxLayoutAlign="start start" class="no-bottom-pad">
    <div style="min-width: 100%;">
      @if (onSubmitDenialDoc) {
      <div style="margin-bottom: 20px;">
       @if (!(isEditorVisible || templateSaving || generatedDocFileName)) {
        <button mat-raised-button color="primary" (click)="onGenerateTemplate()"
          [disabled]="isEditorVisible || templateSaving || generatedDocFileName">
          Generate Template
        </button>
      }
        @if (!isEditorVisible && isReviewVisible && generatedDocFileName) {
          <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="16px">
            <a href="javascript:void(0)" (click)="onViewDocument()">{{generatedDocFileName}}</a>
            <button mat-raised-button color="accent" (click)="onEditTemplate()" [disabled]="templateSaving">
              Edit Template
            </button>
            <button mat-raised-button color="warn" (click)="onClearEdits()" [disabled]="templateSaving">
              Clear Edits
            </button>
          </div>
        }
      </div>
      }
      @if (isEditorVisible) {
        <div class="template-editor">
          <ckeditor *ngIf="editorContent" #editor [editor]="ClassicEditor" [config]="CKEditorConfig" [data]="editorContent"></ckeditor>
        </div>
        <mat-card-actions fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
          <button mat-raised-button color="primary" (click)="onEditorSave()" [disabled]="templateSaving">
            Save
          </button>
          <button mat-raised-button color="warn" (click)="onEditorCancel()" [disabled]="templateSaving">
            Cancel
          </button>
        </mat-card-actions>
      }
    </div>

    <div *ngIf="!isEditorVisible" style="width: 100%">
      @if (!generatedDocFileName || !(uploadedFiles.length == 0)) {
      <div fxLayout="row">
        <div class="indent"></div>
        <div
          style="font-size: 24px; font-weight: bold; margin-bottom: 20px; display: flex; flex-direction: column; align-items: left;">
          {{ 'OR' }}
        </div>
        </div>
      }

      @if(!generatedDocFileName) {
      <!-- File Upload Component -->
      <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
        <mat-label>Upload Request to Intervene Document (Only PDF and Excel files can be attached)</mat-label>
        <input matInput style="display: none" required />

        <app-file-upload #fileUpload
                         [fileUploadInProgress]="fileUploadInProgress"
                         [wrongFileTypeMessage]="requiredFileMessage" [requiredFileType]="requiredFileType"
                         [showAssociatedDocuments]="false" (attachAssociatedDocOutput)="attachAssociatedDocOutput = $event"
                         (primaryEPDSFileListOutput)="onEPDSFileListChange($event)">
        </app-file-upload>
      </mat-form-field>
      }

      <!-- Comments -->
      <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
        <mat-label>Comments</mat-label>
        <textarea matInput [(ngModel)]="comments" name="comments" rows="5" maxlength="250"></textarea>
        <mat-hint>{{ 250 - (comments ? comments.length : 0) }} characters remaining</mat-hint>
      </mat-form-field>

      <mat-card-actions fxLayout="row" fxLayoutAlign="start start">
        <div class="controls">
          <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="templateSaving || !isValid()">
            Submit
          </button>
          <div *appSpinner="templateSaving; diameter: 40; color: 'primary'"></div>
        </div>
        </mat-card-actions>
    </div>
  </mat-card-content>
</mat-card>
